import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.scss";

//import images
import Logo from "../assets/logos/RentlyBuzzLogo.webp";

const navLinks = [
  { href: "#home", label: "Home", scrollTo: "#" },
  { href: "#about", label: "About", scrollTo: "#about" },
  { href: "#features", label: "Features", scrollTo: "#features" },
  { href: "#pricing", label: "Pricing", scrollTo: "#pricing" },
];

// Simple utility for button text splitting (avoiding import complexity)
const splitButtonText = (text) => {
  return text.split("").map((char, i) => (
    <span className="nav-letter" key={i}>
      {char === " " ? "\u00A0" : char}
    </span>
  ));
};

export default function Header({ smoother }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  // Scroll handler: prefer ScrollSmoother.scrollTo if available, else fallback
  const handleScrollTo = (e, scrollTo) => {
    e.preventDefault();
    smoother?.scrollTo(`${scrollTo}`, true, "center center");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="navbar">
      <div className="left">
        <div className="logo-and-text">
          <div className="logo">
            <img src={Logo} alt="RentlyBuzz Logo" />
          </div>
        </div>

        <div className="nav-items">
          {navLinks.map(({ href, label, scrollTo }) => (
            <button
              type="button"
              // data-href kept if needed for debugging; no DOM navigation will be triggered by this attribute
              data-href={href}
              className="nav-link"
              key={href}
              onClick={(e) => handleScrollTo(e, scrollTo)}
            >
              {splitButtonText(label)}
            </button>
          ))}
        </div>
      </div>
      <div className="right">
        <div className="account-dropdown">
          <div className="button" onClick={toggleDropdown}>
            {splitButtonText("My Account").map((span, i) =>
              React.cloneElement(span, {
                key: i,
                className: "button-letter",
              })
            )}
          </div>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div
                className="dropdown-item"
                onClick={() => {
                  navigate("/signin");
                  setIsDropdownOpen(false);
                }}
              >
                {splitButtonText("Landlord").map((span, i) =>
                  React.cloneElement(span, {
                    key: i,
                    className: "button-letter",
                  })
                )}
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  navigate("/signin");
                  setIsDropdownOpen(false);
                }}
              >
                {splitButtonText("Agent").map((span, i) =>
                  React.cloneElement(span, {
                    key: i,
                    className: "button-letter",
                  })
                )}
              </div>
              <div
                className="dropdown-item"
                onClick={() => {
                  navigate("/signin");
                  setIsDropdownOpen(false);
                }}
              >
                {splitButtonText("Tenant").map((span, i) =>
                  React.cloneElement(span, {
                    key: i,
                    className: "button-letter",
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
